<ng-container [ngSwitch]="inputType">
  <div *ngSwitchCase="'dropdown'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <mat-select
        #select
        hideSingleSelectionIndicator="true"
        [formControl]="overlayFormControl"
        [attr.disabled]="overlayFormControl?.disabled"
        (selectionChange)="emitNumericData.emit(overlayFormControl)"
        [placeholder]="'commonLabels.select' | xTranslate"
      >
        <mat-option *ngFor="let val of optionValues" [value]="val.key">
          {{ val.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'textbox'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <input matInput [autocomplete]="false" [formControl]="overlayFormControl" />
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'numeric'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <input matInput (blur)="formatNumericData()" [autocomplete]="false" [formControl]="overlayFormControl" />
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'currency'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <input matInput (blur)="formatNumericData()" [autocomplete]="false" [formControl]="overlayFormControl" />
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'date'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <input
        matInput
        [autocomplete]="false"
        [matDatepicker]="picker"
        [formControl]="overlayFormControl"
        (dateChange)="emitNumericData.emit(overlayFormControl)"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'textarea'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <textarea matInput [formControl]="overlayFormControl"></textarea>
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'masked'">
    <mat-form-field appearance="outline" class="miq-form-input">
      <input matInput [disabled]="true" value="*****" />
    </mat-form-field>
  </div>
  <div *ngSwitchCase="'naics'">
    <sp-naics-input
      [overlayFormControl]="overlayFormControl"
      [value]="value"
      [optionValues]="optionValues"
    ></sp-naics-input>
  </div>
  <div *ngSwitchDefault>
    <mat-form-field appearance="outline" class="miq-form-input">
      <input matInput [disabled]="true" [value]="value" />
    </mat-form-field>
  </div>
</ng-container>
